import "../styles/leisure.css"
import "../styles/art/nightsky.css"

import YoutubePicture from "../../src/assets/images/youtubePreview.PNG"
import RobloxPicture from "../../src/assets/images/robloxGamePreview.PNG"

import { useEffect } from "react"
import { NightSky } from "../components/art/NightSky"

import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

import applyLandscapeAnimation from "../helper/landscapeAnimationHelper"

function PageLeisure() {

    useEffect(() => {
        window.scrollTo(0,0)

        let t1 = gsap.timeline({onStart: setScrollTriggers})
        t1.fromTo(".background-leisure", {backgroundImage: `linear-gradient(to bottom, black 0%, black 80%, black 100%)`,},
        {
            backgroundImage: `linear-gradient(to bottom, rgb(8, 1, 1) 20%, rgb(83, 17, 36) 60%, rgb(151, 4, 4) 100%)`,
            duration: 1,
            ease: "power3.in",
        }, 0)
        t1.fromTo(".main-leisure__section", {
            y: "-50vh",
            opacity: 0
        },
        {
            y: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.25
        }, 0.25)

    }, [])

    function setScrollTriggers() {
        gsap.registerPlugin(ScrollTrigger)
        let tScrollBackground = gsap.timeline()
        let skyAnimTrigger = ScrollTrigger.create({
            trigger: ".main-leisure",
            endTrigger: "body",
            start: "top top",
            end: "bottom bottom",
            scrub: true,
            animation: gsap.fromTo(".sky-background", {
                backgroundImage: `linear-gradient(to bottom, rgb(8, 1, 1) 20%, rgb(83, 17, 36) 60%, rgb(151, 4, 4) 100%)`,
            },
            {
                backgroundImage: `linear-gradient(to bottom, rgb(8, 1, 1) 20%, rgb(8, 1, 1) 60%, rgb(32, 6, 14) 100%)`,
                ease: "power2.in",
                duration: 1
            })
        })

        let mountainTrigger = applyLandscapeAnimation({
            trigger: ".main-leisure",
            endTrigger: "body",
            start: "top top",
            end: "40% top",
            y: "50vh"
        })
        tScrollBackground.add(skyAnimTrigger.animation, 0)
        tScrollBackground.add(mountainTrigger.animation, 0)
    }


    return (
        <>
            <div className="sky-background background-leisure"></div>
            <main className="main-leisure">
                <NightSky></NightSky>
                <h1>What I also do for fun...</h1>
                
                <div className="planet-landscape-container">
                    <div className="planet-iv-mountain-container">
                        <div className="planet-iv-mountain planet-iv-mountain-1"></div>
                    </div>
                    <div className="planet-iv-mountain-container">
                        <div className="planet-iv-mountain planet-iv-mountain-2"></div>
                    </div>
                    <div className="planet-iv-surface-sea"></div>
                    <div className="planet-iv-surface"></div>
                </div>
                <section className="main-leisure__section leisure-pane">
                    <div className="leisure-pane-item item1">
                        <h2>Youtube Channel</h2>
                        <p>I make content for YouTube as a hobby. I make videos that involve coding, storytelling using a specific format of delivery.</p>
                        <div className="leisure-pane-item__img-container">
                            <img src={YoutubePicture} alt="A preview of some videos on my youtube channel" ></img>
                        </div>
                        <div>
                            <a href="https://www.youtube.com/c/kylebarvel" target="_blank" rel="noreferrer" className="link-button">View YouTube Channel</a> 
                        </div>

                    </div>
                    <div className="leisure-pane-item item2">
                        <h2>ROBLOX</h2>
                        <p>I have been gaming in ROBLOX for a really long time. In addition, I have developed a playable
                            experience using the ROBLOX game engine and studio, which involved the use of Lua, a scripting language
                            to program the behavior of key elements of the obstacle course.
                        </p>
                        
                        <div className="leisure-pane-item__img-container">
                            <img src={RobloxPicture} alt="A preview of my created ROBLOX obstacle course game" ></img>
                        </div>
                        <div>
                            <a href="https://www.roblox.com/games/3934295745/Hidden-badges-10000-Ultimate-Obby-2-0" target="_blank" rel="noreferrer" className="link-button">View ROBLOX Experience</a> 
                        </div>
                    </div>
                </section>
            </main>
        </>
        
    )
}

export default PageLeisure